import React from 'react';
import { type Theme, makeStyles, useMediaQuery } from '@material-ui/core';
import { PartnerAdVariant } from '@skyslope/partnerships-sdk';
import { MD_MEDIA_QUERY } from '../common/constants';
import { AdPlacementIds } from './DigiSignAdsProvider';
import { DSAd } from './DSAd';
interface StyleProps {
  isMobile: boolean;
}
const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  dsAdContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
    marginTop: (props: StyleProps) => (props.isMobile ? theme.spacing(2) : theme.spacing(2)),
  },
}));

export function SignerAd() {
  const isMobile = useMediaQuery(MD_MEDIA_QUERY);
  const adVariant = isMobile ? PartnerAdVariant.MobileBanner : PartnerAdVariant.Banner;
  const classes = useStyles({
    isMobile: isMobile,
  });

  return (
    <div className={classes.dsAdContainer}>
      <DSAd id={AdPlacementIds.SIGNING} adVariant={adVariant}></DSAd>
    </div>
  );
}
